import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { DateAdapter, MatNativeDateModule, MatRippleModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';import { CompanyNavComponent } from './components/company-nav/company-nav.component';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { DialogComponent } from './components/dialog/dialog.component';
import { PrimaryNavComponent } from './components/primary-nav/primary-nav.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { EditViewActionsComponent } from './components/edit-view-actions/edit-view-actions.component';
import { IconCoreComponent } from './components/icons/icon-core/icon-core.component';
import { RolloverCssDirective } from './directives/rollover-css.directive';
import { FileDragDropDirective } from './directives/file-drag-drop.directive';
import { ImageRolloverDirective } from './directives/image-rollover.directive';
import { OrganisationRoleDirective } from './directives/organisation-role.directive';
import { ExistingEmailValidator } from './validators/existing-email-validator';
import { ArrayFilterPipe } from './pipes/array-filter-pipe';
import { BooleanValuePipe } from './pipes/boolean-value-pipe';
import { CompanyDatePipe } from './pipes/company-date-pipe';
import { CurrencySymbolPipe } from './pipes/currency-symbol-pipe';
import { EscapeHtmlPipe } from './pipes/escape-html-pipe';
import { TransactionStatusPipe } from './pipes/transaction-status-pipe';
import { GroupEditContainerComponent } from './components/group-edit-container/group-edit-container.component';
import { FieldEditorComponent } from './components/field-editor/field-editor.component';
import { FieldTooltipSuffixComponent } from './components/field-tooltip-suffix/field-tooltip-suffix.component';
import { InputEditCurrencyComponent } from './components/input-edit-currency/input-edit-currency.component';
import { InputEditPercentageComponent } from './components/input-edit-percentage/input-edit-percentage.component';
import { InputEditHelperComponent } from './components/input-edit-helper/input-edit-helper.component';
import { DynamicDirective } from './directives/dynamic.directive';
import { FieldDisplayComponent } from './components/field-display/field-display.component';
import { MenuBaseComponent } from './components/menu-base/menu-base.component';
import { MenuSectionComponent } from './components/menu-section/menu-section.component';
import { MenuSectionButtonComponent } from './components/menu-section-button/menu-section-button.component';
import { LoadingComponent } from './components/loading/loading.component';
import { GroupEditSectionComponent } from './components/group-edit-section/group-edit-section.component';
import { ModalEditorComponent } from './components/modal-editor/modal-editor.component';
import { PaymentMethodStripeComponent } from './components/payment-method-stripe/payment-method-stripe.component';
import { CreatePaymentMethodComponent } from './components/create-payment-method/create-payment-method.component';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';
import { DialogService } from './services/dialog.service';
import { SubscriptionService } from './services/subscription.service';
import { CompanyDynFieldHeaderDirective } from './directives/company-dyn-field-header.directive';
import { CompanyDynFieldLabelDirective } from './directives/company-dyn-field-label.directive';
import { TableLoadingComponent } from '../shared/components/table-loading/table-loading.component';
import { CommonGroupHeaderComponent } from './components/common-group-header/common-group-header.component';
import { DateRangeSelectorComponent } from './components/date-range-selector/date-range-selector.component';
import { GroupEditSectionItemComponent } from './components/group-edit-section-item/group-edit-section-item.component';
import { AssetGroupEditorComponent } from './components/asset-group-editor/asset-group-editor.component';
import { TypeAheadNominalAccountsComponent } from './components/typeAheads/type-ahead-nominal-accounts/type-ahead-nominal-accounts.component';
import { NestedAccountNameComponent } from './components/nested-account-name/nested-account-name.component';
import { GenericStatusIconComponent } from './components/generic-status-icon/generic-status-icon.component';
import { NtBtnComponent } from './components/nt-btn/nt-btn.component';
import { CompanyBaseComponent } from './components/company-base/company-base.component';
import { TabbedCompanyViewComponent } from './components/tabbed-company-view/tabbed-company-view.component';
import { InputEditClassComponent } from './components/input-edit-class/input-edit-class.component';
import { InputEditLocationComponent } from './components/input-edit-location/input-edit-location.component';
import { AccrualGroupEditorComponent } from './components/accrual-group-editor/accrual-group-editor.component';
import { ImportItemsBaseComponent } from './components/import-items-base/import-items-base.component';
import { BaseChartDirective } from 'ng2-charts';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { InputEditDateComponent } from './components/input-edit-date/input-edit-date.component';
import { SubscriptionResourceEditorComponent } from './components/subscription-resource-editor/subscription-resource-editor.component';
import { InvoiceDownloadButtonComponent } from './components/invoice-download-button/invoice-download-button.component';
import { SubscriptionInvalidPaymentBarComponent } from './components/subscription-invalid-payment-bar/subscription-invalid-payment-bar.component';
import { SubscriptionFreeTrialBarComponent } from './components/subscription-free-trial-bar/subscription-free-trial-bar.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { OrgContactEditorComponent } from './components/org-contact-editor/org-contact-editor.component';
import { AddressEditorComponent } from './components/address-editor/address-editor.component';
import { ContactEditorComponent } from './components/contact-editor/contact-editor.component';
import { UserEditorComponent } from './components/user-editor/user-editor.component';
import { GenericStatusComponent } from './components/generic-status/generic-status.component';
import { AlmostLoadedComponent } from './components/almost-loaded/almost-loaded.component';
import { HelpCenterComponent } from './components/help-center/help-center.component';
import { AssetSelectListSharedComponent } from './components/asset-select-list-shared/asset-select-list-shared.component';
import { PostingCellComponent } from './components/posting-cell/posting-cell.component';


@NgModule({
  declarations: [
    CompanyNavComponent,
    DialogComponent,
    PrimaryNavComponent,
    EditViewActionsComponent,
    IconCoreComponent,
    RolloverCssDirective,
    FileDragDropDirective,
    ImageRolloverDirective,
    OrganisationRoleDirective,
    ExistingEmailValidator,
    ArrayFilterPipe,
    BooleanValuePipe,
    CompanyDatePipe,
    CurrencySymbolPipe,
    EscapeHtmlPipe,
    TransactionStatusPipe,
    GroupEditContainerComponent,
    FieldEditorComponent,
    FieldTooltipSuffixComponent,
    InputEditCurrencyComponent,
    InputEditPercentageComponent,
    InputEditHelperComponent,
    DynamicDirective,
    FieldDisplayComponent,
    MenuBaseComponent,
    MenuSectionComponent,
    MenuSectionButtonComponent,
    LoadingComponent,
    GroupEditSectionComponent,
    ModalEditorComponent,
    PaymentMethodStripeComponent,
    CreatePaymentMethodComponent,
    ModalContainerComponent,
    CompanyDynFieldHeaderDirective,
    CompanyDynFieldLabelDirective,
    TableLoadingComponent,
    CommonGroupHeaderComponent,
    DateRangeSelectorComponent,
    GroupEditSectionItemComponent,
    AssetGroupEditorComponent,
    TypeAheadNominalAccountsComponent,
    NestedAccountNameComponent,
    GenericStatusIconComponent,
    NtBtnComponent,
    CompanyBaseComponent,
    TabbedCompanyViewComponent,
    InputEditClassComponent,
    InputEditLocationComponent,
    AccrualGroupEditorComponent,
    ImportItemsBaseComponent,
    AutoFocusDirective,
    InputEditDateComponent,
    SubscriptionResourceEditorComponent,
    InvoiceDownloadButtonComponent,
    SubscriptionInvalidPaymentBarComponent,
    SubscriptionFreeTrialBarComponent,
    LoginFormComponent,
    OrgContactEditorComponent,
    AddressEditorComponent,
    ContactEditorComponent,
    UserEditorComponent,
    GenericStatusComponent,
    AlmostLoadedComponent,
    HelpCenterComponent,
    AssetSelectListSharedComponent,
    PostingCellComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatMomentDateModule,
    BaseChartDirective,
  ],
  exports: [
    CompanyNavComponent,
    PrimaryNavComponent,
    IconCoreComponent,
    RolloverCssDirective,
    FileDragDropDirective,
    ImageRolloverDirective,
    OrganisationRoleDirective,
    ExistingEmailValidator,
    ArrayFilterPipe,
    BooleanValuePipe,
    CompanyDatePipe,
    CurrencySymbolPipe,
    EscapeHtmlPipe,
    TransactionStatusPipe,
    GroupEditContainerComponent,
    GroupEditSectionComponent,
    FieldDisplayComponent,
    DynamicDirective,
    MenuBaseComponent,
    LoadingComponent,
    ModalContainerComponent,
    ModalEditorComponent,
    EditViewActionsComponent,
    IconCoreComponent,
    FieldEditorComponent,
    CompanyDynFieldHeaderDirective,
    CompanyDynFieldLabelDirective,
    TableLoadingComponent,
    CommonGroupHeaderComponent,
    DateRangeSelectorComponent,
    AssetGroupEditorComponent,
    AccrualGroupEditorComponent,
    TypeAheadNominalAccountsComponent,
    NestedAccountNameComponent,
    GenericStatusIconComponent,
    NtBtnComponent,
    CompanyBaseComponent,
    TabbedCompanyViewComponent,
    ImportItemsBaseComponent,
    AutoFocusDirective,
    InputEditClassComponent,
    InputEditLocationComponent,
    PaymentMethodStripeComponent,
    SubscriptionResourceEditorComponent,
    InvoiceDownloadButtonComponent,
    SubscriptionInvalidPaymentBarComponent,
    SubscriptionFreeTrialBarComponent,
    LoginFormComponent,
    OrgContactEditorComponent,
    ContactEditorComponent,
    AddressEditorComponent,
    UserEditorComponent,
    GenericStatusComponent,
    AlmostLoadedComponent,
    HelpCenterComponent,
    PostingCellComponent,

    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatMomentDateModule,
    BaseChartDirective,
  ],
  providers: [
    DialogService,
    SubscriptionService
  ]
})
export class SharedModule { }
